export default interface StockExchange {
    exchange: string
    short: StockExchangeShort
    region: string
    location: string
}

export enum StockExchangeShort {
    BATS = 'BATS',
    BOX = 'BOX',
    BX = 'BX',
    BYX = 'BYX',
    BZX = 'BZX',
    C2 = 'C2',
    CBOE = 'CBOE',
    'Cboe US Equities' = 'Cboe Us Equities',
    CHX = 'CHX',
    CSE = 'CSE',
    IEX = 'IEX',
    ISE = 'ISE',
    LTSE = 'LTSE',
    MEMX = 'MEMX',
    MIAX = 'MIAX',
    MX = 'MX',
    NASDAQ = 'NASDAQ',
    'NASDAQ Canada' = 'NASDAQ Canada',
    NEO = 'NEO',
    NYSE = 'NYSE',
    'NYSE Arca' = 'NYSE Arca',
    'NYSE American' = 'NYSE American',
    PHLX = 'PHLX',
    TSE = 'TSE',
    TSX = 'TSX',
}